<template>
    <div class="ig--content-desc row row-center" v-show="tagName">
        <div class="desc-name" :style="{ 'background-color': mColor(10), 'color': mColor(2.1) }">
            对
            <router-link tag="span" :to="{ name: 'label-detail', params: { label: work_id, tab: 0 } }" class="name-author" v-text="tagName" :style="{ 'color': mColor(4) }"></router-link>
            的{{typeName}}
        </div>
        <slot></slot>
    </div>
</template>

<script>
import mCore from '../../scripts/mixins/core'
export default {
	name: 'igc-item-tag', 
    mixins: [mCore],
	data() {
        return {};
	},
	props: {
        item: {
            type: Object,
            required: true
        }
	},

	computed: {
		km() {
            return this.$store.state.global.knowledgeSpread || {};
        },
        
        work_id() {
            return (this.item.works_id||'').split(',')[0];
        },
        tagName() {
            return (this.km[this.work_id]||{}).name
        },
        typeName() {
            let arr = ((this.km[this.work_id]||{}).items)||[];
            if (arr.length) {
                for (let i = 0, item; item = arr[i]; i++) {
                    if (item.type === 2) {
                        return item.name;
                    }
                }
            } else {
                return '';
            }
        }
	},
    mounted() {
    }
}
</script>

<style lang="postcss">
	
/* 公用标签样式 */
.ig--content-desc {
    font-size: 24px;
    margin-top: 16px;
    .desc-name{
        padding: 10px 30px;
        background: #ccc;
        border-radius: 22px;
        .name-author{
            margin: 0 8px;
        }
    }
}    
</style>